module.exports = __webpack_public_path__ + "img/portrait-id-after.2838bdd8.jpg";